const getRawStatusById = (status) => {
  switch (status) {
    case 0:
    case 2:
    case 4:
      return "error";
    case 1:
      return "success";
    case 3:
      return "info";
    default:
      return "error";
  }
};

export default getRawStatusById;
